import { Model } from '@/models/Model';
export class DeleteFuturePLP extends Model {
    constructor() {
        super(...arguments);
        this.status = 'future';
        this.$name = 'DeleteFuturePLP';
        this.$endpoint = '/commands/delete-student-subjects';
        this.$fillable = ['school', 'status'];
    }
}
